import i18next from 'i18next';

i18next.addResources('en', 'order', {
  ORDER_CONFIRM_TITLE: 'Your Pivot is ordered!',
  ORDER_CONFIRM_MESSAGE:
    'We’ll be in close contact in the spring when your Pivot is ready to ship—giving you plenty of time to choose its perfect spot in your home.',
  YOUR_ORDER_NUMBER_IS: 'Your order number is',
  ORDER_TOTAL: 'Order total',
  SHIPPING: 'Shipping',
  SHIPPING_ADDRESS: 'Shipping Address',
  SHIPPING_INFO: 'Shipping information',
  BILLING_ADDRESS: 'Billing Address',
  CUSTOMER_DETAILS: 'Customer details',
  EMAIL: 'Email: {{email}}',
  TEL: 'Tel: {{tel}}',
  SUBSCRIPTION_EMAIL: 'Email',
  SHIPPING_CHECKBOX:
    "Yes, I'd like email updates from Pivot (including launch announcements, product info). Unsubscribe at anytime.",
  BILLING_CHECKBOX: 'Same as shipping address',
  FULL_NAME: 'Full name',
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
  ADDRESS_LINE: 'Address line',
  APARTMENT: 'Apt/Floor/Suite',
  CITY: 'City',
  ZIP_CODE: 'Zip code',
  STATE: 'State',
  PHONE_NUMBER: 'Phone number',
  BILLING: 'Billing',
  PAYMENT_INFORMATION: 'Payment information',
  ORDER_BUTTON: 'Place your order',
  CARD_NUMBER: 'Card number',
  CVV: 'CVV',
  MAX_LENGTH: '45 characters maximum',
  ONLY_LETTERS: 'only letters allowed',
  LOADING: ''
});
